import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

// Input

export const FlexCard = styled(Card)`
	padding: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 4.4rem;
`;

export const InputContainer = styled.div`
	margin-top: 1rem;
	width: 100%;
	position: relative;
	body[dir='rtl'] & {
		text-align: right;
	}
`;

export const HeaderContainer = styled.div`
	padding-inline: var(--padding-5);
	padding-top: var(--padding-5);
`;

export const StoresContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
	gap: 2.6rem;
	overflow: auto;
	padding-inline: var(--padding-5);
	padding-bottom: var(--padding-5);

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const ConnectionWaysCard = styled(Card)`
	display: flex;
	flex-direction: row;
	width: 100%;
	padding: 3rem;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	:hover {
		border: 1px solid var(--blue);
	}

	&.selected {
		border: 1px solid var(--blue);
		background-color: var(--background-1);
	}

	> input[type='radio'] {
		flex: 0 0 auto;
	}
`;

export const ConnectionWaysContainer = styled.div`
	@media ${Breakpoints.mobile} {
		padding: var(--padding-4);
	}
`;

export const ConnectionWaysButtonContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 2rem;
	flex-direction: column;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const ConnectionWaysTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	> .typography > span {
		color: var(--black);
	}
`;

export const ConnectionWaysCardContent = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	.skeleton {
		min-width: 59px;
	}
`;

export const ConnectionWaysCardTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
`;
